import Config from "../config";
import axios from "axios";
import {notification} from "../helpers";


export function wheelsAdminShift(wheelId){
    return (dispatch) => {
        const data = { wheelId: wheelId };
        
        return axios.post(Config.api.getDomain() + 'wheel/forceShift?wheelId='+wheelId, data, Config.api.getConfig()).then(response => {
                dispatch({
                    type: 'REFRESH_FETCH_TRUE',
                    payload: {key:"SearchTable"}
                });
                dispatch({
                    type: 'WHEELS_ADMIN_SHIFT_SUCCESS',
                    payload: response
                });
                 notification('Hjulen förskjutits');

            }).catch(error => {
                dispatch({
                    type: 'WHEELS_ADMIN_SHIFT_FAILURE',
                    payload: error
                });
                let message = error.response.data.message
                notification('Kunde inte Skifta ' + message)
            })
    }
}

export function wheelsShift(wheelIds) {
    return (dispatch) => {
        const data = {
            wheelIds: wheelIds,
            wheelChangerId: Config.api.getWheelChangerId()
        }
        return axios.post(Config.api.getDomain() + 'wheel/shift', data, Config.api.getConfig())
            .then(response => {
                dispatch({
                    type: 'REFRESH_FETCH_TRUE',
                    payload: {key:"ShiftTable"}
                });
                dispatch({
                    type: 'WHEELS_SHIFT_SUCCESS',
                    payload: {key:"ShiftTable"}
                });
                // notification('Hjulen förskjutits');

            })
            .catch(error => {
                dispatch({
                    type: 'WHEELS_SHIFT_FAILURE',
                    payload: {key:"ShiftTable"}
                });
                //let message = error.response.data.message
                // notification('Kunde inte Skifta: ' + message)
            })
    }
}

export function wheelsReverseShift(wheelIds) {
    return (dispatch) => {
        axios.post(Config.api.getDomain() + 'wheel/reverseShifted', wheelIds, Config.api.getConfig())
        .then(response => {
            dispatch({
                type: 'REFRESH_FETCH_TRUE',
                payload: {key:"ShiftTable"}
            });

            dispatch({
                type: 'WHEELS_REVERSE_SHIFT_SUCCESS',
                payload: {key:"ShiftTable"}
            });
            // notification('Hjulen förskjutits');
        })
        .catch(error => {
            dispatch({
                type: 'WHEELS_REVERSE_SHIFT_FAILURE',
                payload: {key:"ShiftTable"}
            });
            //let message = error.response.data.message
            // notification('Kunde inte Skifta: ' + message);
        })
    }
}

export function wheelsReturnWithoutShift(wheelIds) {
    return (dispatch) => {
        const data = {
            wheelIds: wheelIds,
            wheelChangerId: Config.api.getWheelChangerId()
        }
        return axios.post(Config.api.getDomain() + 'wheel/moveToShifted', data, Config.api.getConfig())
            .then(response => {
                dispatch({
                    type: 'REFRESH_FETCH_TRUE',
                    payload: {key:"ShiftTable"}
                });
                dispatch({
                    type: 'WHEELS_SHIFT_SUCCESS',
                    payload: {key:"ShiftTable"}
                });
                // notification('Hjulen förskjutits');

            })
            .catch(error => {
                dispatch({
                    type: 'WHEELS_SHIFT_FAILURE',
                    payload: {key:"ShiftTable"}
                });
                //let message = error.response.data.message
                // notification('Kunde inte Skifta: ' + message)
            })
    }
}

export function searchWheels(searchQuery){
    return (dispatch) => {

        dispatch({
            type:'WHEELS_SEARCH_REQUEST',
            payload:true
        });

        dispatch({
            type: 'REFRESH_FETCH_FALSE',
            payload: {key:"SearchTable"}
        });

        axios.get(Config.api.getDomain() + 'wheel/search/' + searchQuery + '', Config.api.getConfig()).then(res => {

                let wheelsOnCar = [];
                let wheelsOnStation = [];
                let wheelsOnDelivery = [];
                let wheelsInWarehouse= [];
                let wheelsAtWheelDistributor =[];

                let x = null;
                for (x in res.data) {
                    if (res.data[x].wheelStatus.name==="OnCar"){

                        wheelsOnCar.push(res.data[x]);
                    }

                    if (res.data[x].wheelStatus.name==="OnStation"){
                        wheelsOnStation.push(res.data[x]);
                    }

                    if (res.data[x].wheelStatus.name==="OnDelivery"){
                        wheelsOnDelivery.push(res.data[x]);
                    }

                    if (res.data[x].wheelStatus.name==="InWarehouse"){
                        wheelsInWarehouse.push(res.data[x]);
                    }

                    if (res.data[x].wheelStatus.name==="AtWheelDistributor"){
                        wheelsAtWheelDistributor.push(res.data[x]);
                    }


                }

                dispatch({
                    type: 'WHEELS_SEARCH_SUCCESS',
                    payload: {
                        wheelsOnCar: wheelsOnCar,
                        wheelsOnStation: wheelsOnStation,
                        wheelsOnDelivery: wheelsOnDelivery,
                        wheelsInWarehouse: wheelsOnDelivery,
                        wheelsAtWheelDistributor: wheelsAtWheelDistributor
                    }
                });



            }).catch(error => {
                console.log(error);
                dispatch({
                    type: 'WHEELS_SEARCH_FAILURE',
                    payload: {
                        wheelsOnCar: [],
                        wheelsOnStation: [],
                        wheelsOnDelivery: [],
                        wheelsInWarehouse: [],
                        wheelsAtWheelDistributor:[]
                    }
                });
            });
    }
}


// WEBPACK FOOTER //
// ./src/actions/wheels.js